import * as React from 'react';
import isNil from 'lodash/isNil';
import limitationStore from '@globalStore/limitationStore';
import {
  getAppFlowIdFromUsecaseKey,
  getAppFrustrationSignalIdFromUsecaseKey,
  getAppEventIdFromUsecaseKey,
} from '@src/utils/preset';
import { useDrilldownMeta } from '@src/hooks/common/useDrilldownMeta';

// To get the current limitation of preset dashboard.
// TODO: This is a temporary solution, can be removed after move the limitation to the backend.
export function useCurrentLimitation() {
  const { useCaseKey, widgetMeta } = useDrilldownMeta();

  return React.useMemo(
    () =>
      getLimitationByUsecaseKey(
        useCaseKey,
        widgetMeta?.flowId,
        widgetMeta?.frustrationSignalId,
        widgetMeta?.eventId,
      ),
    [useCaseKey, widgetMeta?.flowId, widgetMeta?.frustrationSignalId, widgetMeta?.eventId],
  );
}

export function getLimitationByUsecaseKey(
  usecaseKey: string,
  flowId?: number | string,
  frustrationSignalId?: number | string,
  eventId?: string,
) {
  const { limitations } = limitationStore.getState();
  const defaultLimitation = limitations.default;
  const flowPresetId = getAppFlowIdFromUsecaseKey(usecaseKey) || flowId;
  const frustrationSignalPresetId =
    getAppFrustrationSignalIdFromUsecaseKey(usecaseKey) || frustrationSignalId;
  const eventPresetId = getAppEventIdFromUsecaseKey(usecaseKey) || eventId;

  // Check for frustration signal limitation first
  if (!isNil(frustrationSignalPresetId)) {
    return limitations[`frustration-signal-${frustrationSignalPresetId}`] || defaultLimitation;
  }

  // Then check for flow limitation
  if (!isNil(flowPresetId)) {
    return limitations[`flow-${flowPresetId}`] || defaultLimitation;
  }

  // Then check for event preset limitation
  if (!isNil(eventPresetId)) {
    return limitations[`event`] || defaultLimitation;
  }

  return limitations[usecaseKey] ?? defaultLimitation;
}
